module.exports = {
      id: "logo-usage",
      viewBox: "0 0 119 39",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#logo",
      toString: function () {
        return this.url;
      }
    }